module.exports = __webpack_public_path__ + "img/logo_contest_brochure.4db79832.jpg";